// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/intakeConsent.ts

/**
 * Canonical Community Navigator consent check used by forwarding and UI gates.
 * Matches portal-community-navigator-case-forward getConsentAccepted semantics
 * for intake-answer values (body.consentAccepted boolean is forward-only).
 */
export function isNavigatorConsentAccepted(value: unknown): boolean {
  return value === "yes" || value === true;
}

export function getConsentAcceptedFromIntakeAnswers(
  intakeAnswers: unknown
): unknown {
  if (!intakeAnswers || typeof intakeAnswers !== "object") return null;
  const standard = (intakeAnswers as { standardRequestInformation?: unknown })
    .standardRequestInformation;
  if (!standard || typeof standard !== "object") return null;
  return (standard as { consentAccepted?: unknown }).consentAccepted ?? null;
}

export function hasRecordedNavigatorConsent(
  intakeAnswers: unknown
): boolean {
  return isNavigatorConsentAccepted(
    getConsentAcceptedFromIntakeAnswers(intakeAnswers)
  );
}

/** Exact backend forward error when completed Intake consent is missing. */
export const CONSENT_REQUIRED_FORWARD_MESSAGE =
  "Consent must be recorded before forwarding to a provider.";

export function isConsentRequiredForwardError(
  message: string | null | undefined
): boolean {
  return String(message || "").trim() === CONSENT_REQUIRED_FORWARD_MESSAGE;
}

/** Intake step index for Basics (consent lives here). */
export const INTAKE_BASICS_STEP_INDEX = 0;

export const INTAKE_CONSENT_FIELD_ID = "cn-intake-consent-accepted";
